<!--<div class="example-list" cdkDropList (cdkDropListDropped)="drop($event)">
<div class="example-box" *ngFor="let item of addedFields" cdkDrag>
  {{ item.Translation }}
</div>
</div>-->



<div class="search-fields-settings">
  <div class="pop-header">
    <div class="left">
      <img src="/assets/css/images/platform/modify-settings.png" />
      <label class="label">{{translate('galis_js_SearchForm_ModifySearch')}}</label>
    </div>
    <div class="right" (click)="cancelSearchSettings()">
      <img src="/assets/css/images/platform/close-icon.png" />
    </div>
  </div>

  <div class="title-div">
    <label class="fields-main-label">{{translate('galis_js_AdditionalSearchFields')}}</label>
  </div>

  <div class="drag-drop-content">
    <div class="left-container">
      <div class="info">
        <label>{{translate('galis_js_SearchForm_AvailibleFields')}}:</label>
        <input type="text" placeholder="{{translate('galis_js_SearchForm_FindPlaceholder')}}"
          (input)="fieldSearch($event.target.value)" />
        </div>


        <div class="all-search-fields">
          <ul>
            <ng-scrollbar [visibility]="'hover'">
              @for (item of availibleFields; track item) {
                <li [ngClass]="{'active': selectedItem == item}" (click)="listItemClick($event, item)"
                  (dblclick)="doubleClickAdd($event, item)"
                  [matTooltip]="item.Translation" [matTooltipPosition]="'left'" matTooltipClass="searchproperty-tooltip">
                  {{ item.Translation }}
                </li>
              }
            </ng-scrollbar>
          </ul>
        </div>

      </div>

      <div class="action-buttons">
        <div class="add" (click)="addSearchField()"
        style="background-image:url(/assets/css/images/platform/add-right@3x.png)"></div>
        <div class="remove" (click)="removeAddedSearchField()"
        style="background-image:url(/assets/css/images/platform/add-left@3x.png)"></div>
      </div>

      <div class="right-container">
        <label>{{translate('galis_js_SearchForm_YourSettings')}}:</label>

        <div class="added-search-fields" cdkDropList (cdkDropListDropped)="drop($event)">
          <ul>
            <ng-scrollbar [visibility]="'hover'">
              @for (item of addedFields; track item) {
                <li [ngClass]="{'active': selectedItem == item}" (click)="listItemClick($event, item)"
                  (dblclick)="doubleClickRemove($event, item)" cdkDrag
                  [matTooltip]="item.Translation" [matTooltipPosition]="'right'" matTooltipClass="searchproperty-tooltip">
                  {{ item.Translation }}
                </li>
              }
            </ng-scrollbar>
          </ul>
        </div>

      </div>
    </div>
    <span class="right-span">{{translate('galis_js_SearchForm_DragLabel')}}</span>

    <div class="footer">
      <div class="left-footer" (click)="restoreSearchSettings()">
        <span>{{translate('galis_js_SearchForm_RestoreButton')}}</span>
      </div>
      <div class="right-footer">
        <!--<div class="apply" (click)="applySearchSettings()">
        <span>APPLY</span>
      </div>-->
      <div class="save" (click)="saveUserAdditionalSearchFields(false)">
        <span>{{translate('galis_js_SearchForm_SaveButton')}}</span>
      </div>
      <div class="cancel" (click)="cancelSearchSettings()">
        <span>{{translate('galis_js_SearchForm_CancelButton')}}</span>
      </div>
    </div>
  </div>
</div>
